import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_ARCHIVED_EMPLOYEES_INIT,
});

export const success = data => ({
  type: USER.GET_ARCHIVED_EMPLOYEES_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_ARCHIVED_EMPLOYEES_FAILURE,
});

const getArchivedEmployees = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getArchivedEmployees();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getArchivedEmployees;
